export class RecursosHumanos {}
